import { useContext } from 'react'

import { ScheduleContext } from '~/contexts/ScheduleContext'

export const useSchedule = () => {
  return useContext(ScheduleContext)  
}